import React, { useContext, useEffect, useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import RegisterLayout from "./RegisterLayout";
import InputFieldV2 from "../../../lib/input/InputFieldV2";
import { defaultPreviousRole } from "../../../data/formData";
import DropDownV2 from "../../../global/ui/DropDownV2";
import { preConfigDeptData } from "../../../data/data";
import { emptyFunction, setDropdownSelectedValue } from "../../../utils";
import { apiConstants } from "../../../utils/apiConstants";
import { REQUIRED_VALIDATION } from "../../../lib/input/validation-rules";
import { errorMessage } from "../../../utils/constants";
import { makeGetCall } from "../../../effects/requests";
import { MyContext } from "../../../context";
import { endPoints } from "../../../utils/endpoints";
import ReviewJobs from "./ReviewJobs";
interface StepAddJobsProps {
    onNext: (data: any) => void;
    onPrevious: () => void;
    onPass: () => void;
}

const StepAddJobs: React.FC<StepAddJobsProps> = ({ onNext, onPrevious, onPass }) => {

    const { ...methods } = useForm({
        mode: 'all',
        defaultValues: { ...defaultPreviousRole() },
        reValidateMode: 'onBlur',
    });

    const [allRoles, setAllRoles] = useState([])

    const { formState, handleSubmit, register, watch } = methods;

    const { userData } = useContext(MyContext)

    const onSubmit: SubmitHandler<any> = (values: any) => {
        onNext(values);
    };

    useEffect(() => {
        register(apiConstants.department, { required: errorMessage.required_validation("Department") });
    }, []);


    const department: any = watch(apiConstants.department) || [];

    const hasValue = Object.values(methods.watch()).some(value => String(value || '').trim() !== '');

    const onHandleSubmit = (evt: any) => {
        evt.preventDefault();
        if (!hasValue) {
            methods.clearErrors();
            onPass();
            return
        }
        handleSubmit(onSubmit)()
    }

    const fetchUserPrevRole = () => {
        makeGetCall(endPoints.PREVIOUS_WORK, { user_id: userData?.id }).then((res: any) => {
            if (res?.status?.code == 200) {
                setAllRoles(res?.results)
            }
        }).catch(emptyFunction)
    }

    useEffect(() => {
        fetchUserPrevRole()
    }, [])

    return (
        <RegisterLayout showLogout hideHeader>
            <FormProvider
                {...methods}>
                <form
                    onSubmit={onHandleSubmit}
                    noValidate
                >
                    <div className="register-step">
                        {/* Heading block */}
                        <div className="register-step__heading-block">
                            <h1 className="register-step__title">
                                Add your<br />previous jobs
                            </h1>
                            <p className="register-step__description">
                                Add in your previous jobs and the role you took on them, this will
                                help expand your profile, increase your credibility, and connect
                                with crew.
                            </p>
                        </div>

                        {/* Jobs forms */}
                        <div className="add-jobs__list">
                            <ReviewJobs jobList={allRoles} />
                            <div className="add-jobs__row">
                                <div className="add-jobs__field">
                                    <label className="add-jobs__label">Department</label>
                                    <DropDownV2
                                        className="arrow-fill drop-down-over-vis height-100"
                                        data={preConfigDeptData}
                                        selectedItems={setDropdownSelectedValue(preConfigDeptData, department)}
                                        onSelect={(data) => { methods.setValue(apiConstants.department, data?.label, { shouldValidate: true }) }}
                                        placeholder="Select department"
                                        errorMessage={formState.errors?.[apiConstants.department]?.message}
                                    />
                                </div>
                                <div className="add-jobs__field">
                                    <label className="add-jobs__label">Positions</label>
                                    <InputFieldV2
                                        name={apiConstants.position}
                                        type="text"
                                        placeholder="Enter positions"
                                        rules={REQUIRED_VALIDATION('Positions')}
                                    />
                                </div>
                            </div>
                            <div className="add-jobs__row">
                                <div className="add-jobs__field">
                                    <label className="add-jobs__label">Production</label>
                                    <InputFieldV2
                                        name={apiConstants.production}
                                        type="text"
                                        placeholder="Enter production"
                                        rules={REQUIRED_VALIDATION('Production')}
                                    />
                                </div>
                                <div className="add-jobs__field">
                                    <label className="add-jobs__label">Studio</label>
                                    <InputFieldV2
                                        name={apiConstants.studio}
                                        type="text"
                                        placeholder="Enter studio"
                                        rules={REQUIRED_VALIDATION('Studio')}
                                    />
                                </div>
                            </div>
                            <div className="add-jobs__field">
                                <label className="add-jobs__label">IMDB</label>
                                <InputFieldV2
                                    name={apiConstants.imdb_link}
                                    type="text"
                                    placeholder="Enter IMDB"
                                    rules={REQUIRED_VALIDATION('IMDB')}
                                />
                            </div>
                        </div>

                        <div className="register-step__footer">
                            <button
                                className="btn-next btn-next--yellow"
                                type="button"
                                style={{ marginRight: 15 }}
                                onClick={onPrevious}
                            >
                                Previous
                            </button>
                            <button
                                className="btn-next btn-next--yellow"
                                type="submit"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </form>
            </FormProvider>
        </RegisterLayout>
    );
};

export default StepAddJobs;